import { Base } from '../../components/BaseComponent';
import { Lightning, Log, Router } from '@lightningjs/sdk';
import { dialogTSpec, dialogTypeConf } from './Dialog.conf';
import { Modal } from '../modal/Modal';

export class Dialog extends Base<dialogTSpec, dialogTypeConf> {
  static override _template() {
    return {
      w: (w: number) => w,
      h: (h: number) => h,
      Container: {
        type: Lightning.Component,
        w: (w: number) => w,
        h: (h: number) => h,
        visible: false,
      },
    };
  }

  private container = this.getByRef('Container')!;
  private parentModal = '';
  private focusStack: Lightning.Element[] = [];

  override _getFocused(): any {
    if (this.focusStack.length !== 0) {
      return this.focusStack[this.focusStack.length - 1];
    } else {
      return this;
    }
  }

  $openDialog(template: any, stack = false) {
    try {
      Log.info('Opening dialog', template);

      if (this.focusStack.length === 0) {
        this.parentModal = (Router.getActiveWidget() as Modal)?.name;
      }
      Router.focusWidget('Dialog');

      this.container.visible = true;
      if (!stack) this.clearChildList();
      template.zIndex = this.container.childList.length;
      const el = this.container.childList.a(template);
      this.focusStack.push(el);
      this._refocus();
    } catch (e: any) {
      this.fireAncestors(
        '$showToast',
        `[Dialog.ts] Open dialog Catch ${e} \n ${JSON.stringify(e)} \n ${e.stack}`,
        4000
      );
    }
  }

  $closeDialog() {
    Log.info('Closing dialog');

    this.container.visible = this.container.childList.length > 0;
    const dialogchild = this.container.childList.removeAt(this.container.children.length - 1);
    this.focusStack = this.focusStack.filter(el => el !== dialogchild);

    this._refocus();
    if (this.focusStack.length === 0) {
      if (this.parentModal) {
        Router.focusWidget(this.parentModal);
        this.parentModal = '';
      } else {
        Router.focusPage();
      }
    }
  }

  private clearChildList() {
    this.container.childList.forEach(child => {
      this.focusStack = this.focusStack.filter(el => el !== child);
    });
    this.container.childList.clear();
  }

  override _handleKey(): void {}
}
